import { defineStyleConfig as d } from "@chakra-ui/react";
import { isTouchScreenDevice as n } from "../../theme-helper.js";
import { ThemeColorVariable as r } from "../../theme-types.js";
import { ThemeColorToken as o, ThemeBorderToken as e, ThemeSpaceToken as l, ThemeRadiusToken as i, ThemeFontToken as c } from "../theme-tokens.js";
const a = {
  fontFamily: c.Body,
  color: o.OnSurface,
  border: e.XSmall,
  borderColor: o.OnSurfaceBorder,
  background: o.Surface,
  borderRadius: i.Small,
  paddingX: l.Medium,
  paddingY: "12px",
  width: "100%",
  _disabled: {
    cursor: "not-allowed",
    background: o.SurfaceDisabled,
    color: o.OnSurfaceSubdued,
    border: 0,
    opacity: 1
  },
  _readOnly: {
    color: o.OnSurface,
    background: o.SurfaceDisabled,
    userSelect: "text",
    opacity: 1,
    border: 0
  },
  _placeholder: {
    color: o.OnSurfaceSubdued,
    opacity: 1
  },
  _invalid: {
    borderColor: o.Error,
    boxShadow: `0 0 0 4px ${r.ErrorContainer}`
  },
  _hover: {
    borderColor: n() ? o.OnSurfaceBorder : o.OnSurface,
    _disabled: void 0,
    _readOnly: void 0
  },
  _focus: {
    borderColor: o.Info,
    boxShadow: `0 0 0 4px ${r.InfoContainer}`
  }
}, t = {
  ...a,
  border: "none",
  _focus: {
    border: e.XSmall,
    borderColor: o.Info,
    boxShadow: `0 0 0 4px ${r.InfoContainer}`
  },
  "@media(hover: hover)": {
    "&:hover": {
      borderColor: o.Info
    },
    "&:hover:not(:focus)": {
      backgroundColor: o.SurfaceDisabled,
      borderColor: o.OnSurfaceBorder
    }
  },
  _invalid: {
    border: e.XSmall,
    borderColor: o.Error,
    boxShadow: `0 0 0 4px ${r.ErrorContainer}`
  }
}, s = d({
  variants: {
    unstyled: a,
    ghost: t
  },
  defaultProps: {
    variant: "unstyled"
  }
});
export {
  s as textareaConfig
};
